import Vue from "vue";
// import md5 from "js-md5";
import router from "@/router";
import config from "@/config";
import errorTags from "@/errorTags";

export default {
  namespaced: true,
  state: {
    _loading: {
      login: false,
      logout: false,
      firstTime: false,
      security: false,
      updatePassword: false,
      getAgentDetail: false,
      getSubDetail: false
    },
    attachmentPath: "",
    sessionToken: "",
    accountId: "",
    loginId: "",
    username: "",
    password: "",
    authorityRole: "",
    account: [],
    account_profile: [],
    account_authority: [],
    alertOn: true,
    daily_statement: {
      target_account_id: '',
      start_date: '',
      end_date: ''
    },
    win_lose: {
      target_account_id: '',
      start_date: '',
      end_date: '',
      account_type: '',
      search_id: ''
    },
    game_result: {
      target_account_id: '',
      start_date: '',
      end_date: ''
    },
    transfer_list: {
      target_account_id: '',
      date: '',
      search_id: '',
      request_type: ''
    },
    bonus_and_adjustment: {
      target_account_id: '',
      search_id: '',
      date: ''
    },
    daily_statement_nest: {
      target_account_id: '',
      start_date: '',
      end_date: ''
    },
    win_lose_nest: {
      target_account_id: '',
      start_date: '',
      end_date: '',
      search_id: ''
    },
  },
  mutations: {
    update(state, payload) {
      state.account = payload.user.account;
      state.account_authority = payload.user.account_authority;
      state.account_profile = payload.user.account_profile;
      state.sessionToken = payload.sessionToken;
      state.username = payload.loginId;
      state.loginId = payload.loginId;
      state.accountId = payload.user.account[0].account_id;
      state.authorityRole = payload.authorityRole;
      state.alertOn = true;
    },
    delete(state) {
      state.attachmentPath = "";
      state.sessionToken = "";
      state.accountId = "";
      state.loginId = "";
      state.username = "";
      state.password = "";
      state.authorityRole = "";
      state.alertOn = null;
      state.account = [];
      state.account_authority = [];
      state.account_profile = [];
      state.daily_statement.target_account_id = "";
      state.daily_statement.start_date = "";
      state.daily_statement.end_date = "";
      state.win_lose.target_account_id = "";
      state.win_lose.start_date = "";
      state.win_lose.end_date = "";
      state.win_lose.account_type = "";
      state.win_lose.search_id = "";
      state.game_result.target_account_id = "";
      state.game_result.start_date = "";
      state.game_result.end_date = "";
      state.transfer_list.target_account_id = "";
      state.transfer_list.date = "";
      state.transfer_list.search_id = "";
      state.transfer_list.request_type = "";
      state.bonus_and_adjustment.target_account_id = "";
      state.bonus_and_adjustment.search_id = "";
      state.bonus_and_adjustment.date = "";
      state.daily_statement_nest.target_account_id = "";
      state.daily_statement_nest.start_date = "";
      state.daily_statement_nest.end_date = "";
      state.win_lose_nest.target_account_id = "";
      state.win_lose_nest.start_date = "";
      state.win_lose_nest.end_date = "";
      state.win_lose_nest.search_id = "";
    },
    loading(state, payload) {
      if ("action" in payload) {
        const action = payload.action;
        const status = payload.status;
        state._loading[action] = status;
      }
    },
    updateAlertOn(state, payload) {
      state.alertOn = payload;
    },
    updateSecurity(state, payload) {
      state.account_profile[0].security_tag = payload.security_tag;
      state.account_profile[0].security_disabled = payload.security_disabled;
    },
    updateAccountSetup(state, payload) {
      state.account[0].min_deposit = payload.min_deposit;
      state.account[0].min_withdrawal = payload.min_withdrawal;
      state.account[0].min_balance = payload.min_balance;
    },
    updateAccountSelfOperate(state, payload) {
      state.account[0].self_operate = payload;
    },
    updateAccountAuthorityOption(state, payload) {
      state.account_authority[0].authority_option = payload;
    },
    updateAttachmentPath(state, payload) {
      state.attachmentPath = payload;
    },
    updateDailyStatementParam(state, payload) {
      state.daily_statement = payload;
    },
    updateWinLoseParam(state, payload) {
      state.win_lose = payload;
    },
    updateGameResultParam(state, payload) {
      state.game_result = payload;
    },
    updateTransferListParam(state, payload) {
      state.transfer_list = payload;
    },
    updateBonusAndAdjustmentParam(state, payload) {
      state.bonus_and_adjustment = payload;
    },
    updateDailyStatementNestParam(state, payload) {
      state.daily_statement_nest = payload;
    },
    updateWinLoseNestParam(state, payload) {
      state.win_lose_nest = payload;
    },
  },
  actions: {
    login(context, user) {
      const url = config.loginUrl();
      const body = {
        login_id: user.username,
        password: user.password
      };

      const feedback = {
        redirect: "",
        success: false,
        status: errorTags.login.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("username" in user)) {
          feedback.status = errorTags.login.usernameRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("password" in user)) {
          feedback.status = errorTags.login.passwordRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.username.length <= 0) {
          feedback.status = errorTags.login.usernameRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.password.length <= 0) {
          feedback.status = errorTags.login.passwordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.login == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "login", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "login", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;

                if (feedback.success == true) {

                  var sessionToken = null;
                  var authorityRole = null;
                  var profileStatus = null;
                  var securityDisabled = null;
                  var loginId = null;
                  var accountType = null;
                  var role = null;
                  var selfOperate = null;

                  try {
                    user.account_profile = successResponse.body.value.account_profile;
                    user.account_authority = successResponse.body.value.account_authority;
                    user.account = successResponse.body.value.account;
                    sessionToken = successResponse.body.value.account_login[0].auth_token;
                    loginId = successResponse.body.value.account_login[0].login_id;
                    authorityRole = successResponse.body.value.account_login[0].authority_role;
                    role = successResponse.body.value.account_login[0].authority_role;

                    if (sessionToken) {
                      profileStatus = successResponse.body.value.account_profile[0].status;
                      switch (profileStatus) {
                        case "NEW":
                          if (role == "SUB_PRI") {
                            feedback.redirect = "/resetPassword";
                          } else {
                            feedback.redirect = "/firstTime";
                          }
                          break;
                        case "RESET":
                          securityDisabled = successResponse.body.value.account_profile[0].security_disabled;

                          if (securityDisabled) {
                            feedback.redirect = "/resetPassword";
                          } else {
                            feedback.redirect = "/security";
                          }
                          break;
                        case "ACTIVE":
                          securityDisabled = successResponse.body.value.account_profile[0].security_disabled;
                          accountType = successResponse.body.value.account[0].account_type;
                          role = successResponse.body.value.account_login[0].authority_role;
                          selfOperate = successResponse.body.value.account[0].self_operate;

                          if (securityDisabled) {
                            if (role == "SUB_PRI")
                              feedback.redirect = "/system/setting";
                            else {
                              if (accountType && accountType == 2) {
                                feedback.redirect = "/account/member";
                              }
                              else
                                feedback.redirect = "/account/operator";
                            }
                          } else {
                            feedback.redirect = "/security";
                          }
                          break;
                      }
                      context.commit("update", { sessionToken, authorityRole, loginId, user });

                      resolve(feedback);
                    } else {
                      context.commit("delete");
                      feedback.success = false;
                      feedback.status = errorTags.login.failed;
                      reject(feedback);
                    }
                  } catch (error) {
                    context.commit("delete");
                    feedback.success = false;
                    feedback.status = errorTags.login.failed;
                    reject(feedback);
                  }
                } else {
                  context.commit("delete");
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "login", status: false });
              context.commit("delete");
              feedback.error = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    firstTime(context, user) {
      const url = config.addSecondaryUrl();
      const body = {
        login_id: this.state.user.loginId,
        new_login_id: user.new_username,
        new_password: user.new_password,
        security_tag: user.security_tag,
        security_code: user.security_code,
        audit_by: this.state.user.loginId,
        action_by: this.state.user.loginId,
        auth_token: this.state.user.sessionToken,
        account_id: this.state.user.accountId
      };
      const feedback = {
        redirect: "",
        success: false,
        status: errorTags.firstTime.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("new_username" in user)) {
          feedback.status = errorTags.firstTime.newUsernameRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("new_password" in user)) {
          feedback.status = errorTags.firstTime.newPasswordRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("security_tag" in user)) {
          feedback.status = errorTags.firstTime.securityTagRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("security_code" in user)) {
          feedback.status = errorTags.firstTime.securityCodeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.new_username.length <= 0) {
          feedback.status = errorTags.firstTime.newUsernameRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.new_password.length <= 0) {
          feedback.status = errorTags.firstTime.newPasswordRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.security_tag.length <= 0) {
          feedback.status = errorTags.firstTime.securityTagRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.security_code.length <= 0) {
          feedback.status = errorTags.firstTime.securityCodeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.firstTime == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "firstTime", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "firstTime", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {

                    feedback.redirect = "/security";
                    resolve(feedback);
                  } catch (error) {
                    //context.commit("delete");
                    feedback.success = false;
                    feedback.status = errorTags.firstTime.failed;
                    reject(feedback);
                  }
                } else {
                  // context.commit("delete");
                  reject(feedback);
                }
              } else {
                // Response is empty...
                //context.commit("delete");
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "firstTime", status: false });
              //context.commit("delete");
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    security(context, user) {
      const url = config.securityValidateUrl();
      const body = {
        profile_id: user.profile_id,
        security_code: user.security_code,
        action_by: this.state.user.loginId,
        auth_token: this.state.user.sessionToken,
        account_id: this.state.user.accountId
      };
      const feedback = {
        redirect: "",
        success: false,
        status: errorTags.security.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("profile_id" in user)) {
          feedback.status = errorTags.security.profileIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("security_code" in user)) {
          feedback.status = errorTags.security.securityCodeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.profile_id.length <= 0) {
          feedback.status = errorTags.security.profileIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.security_code.length <= 0) {
          feedback.status = errorTags.security.securityCodeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.security == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "security", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "security", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    if (this.state.user.authorityRole && this.state.user.authorityRole == 'SUB_PRI') {
                      feedback.redirect = "/system/setting";
                    } else {
                      if (this.state.user.account[0] && this.state.user.account[0].account_type == 2) {
                        feedback.redirect = "/account/member";
                      } else
                        feedback.redirect = "/account/operator";
                    }
                    resolve(feedback);
                  } catch (error) {
                    //context.commit("delete");
                    feedback.success = false;
                    feedback.status = errorTags.security.failed;
                    reject(feedback);
                  }
                } else {
                  // context.commit("delete");
                  reject(feedback);
                }
              } else {
                // Response is empty...
                //context.commit("delete");
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "firstTime", status: false });
              //context.commit("delete");
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updatePassword(context, user) {
      const url = config.passwordUpdateUrl();
      const body = {
        auth_token: this.state.user.sessionToken,
        action_by: this.state.user.loginId,
        login_id: this.state.user.loginId,
        profile_id: this.state.user.account_profile[0].profile_id,
        password: user.password,
        new_password: user.new_password,
        account_id: this.state.user.accountId
      };
      const feedback = {
        success: false,
        status: errorTags.updatePassword.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("password" in user)) {
          feedback.status = errorTags.updatePassword.passwordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("new_password" in user)) {
          feedback.status = errorTags.updatePassword.newPasswordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.password.length <= 0) {
          feedback.status = errorTags.updatePassword.passwordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.new_password.length <= 0) {
          feedback.status = errorTags.updatePassword.newPasswordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updatePassword == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "updatePassword", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updatePassword",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.status = errorTags.updatePassword.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updatePassword",
                status: false
              });
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getAgentDetail(context, user) {
      const url = config.accountAgentDetailUrl();
      const body = {
        auth_token: this.state.user.sessionToken,
        action_by: this.state.user.loginId,
        source_account_id: this.state.user.account[0].parent_id,
        target_account_id: this.state.user.accountId
      };
      const feedback = {
        success: false,
        status: errorTags.getAgentDetail.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (this.state.user._loading.getAgentDetail == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "getAgentDetail", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getAgentDetail",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    context.commit("updateAccountSelfOperate", successResponse.body.dt[0].self_operate);
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.status = errorTags.getAgentDetail.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getAgentDetail",
                status: false
              });
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getSubDetail(context, user) {
      const url = config.accountSubDetailUrl();
      const body = {
        auth_token: this.state.user.sessionToken,
        action_by: this.state.user.loginId,
        account_id: this.state.user.accountId,
        sub_login_id: this.state.user.loginId
      };
      const feedback = {
        success: false,
        status: errorTags.getSubDetail.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (this.state.user._loading.getSubDetail == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "getSubDetail", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getSubDetail",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    context.commit("updateAccountAuthorityOption", successResponse.body.dt[0].authority_option);
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.status = errorTags.getSubDetail.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getSubDetail",
                status: false
              });
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    logout(context) {
      const feedback = {
        success: true,
        status: errorTags.logout.succeed
      };
      return new Promise(resolve => {
        context.commit("delete");
        resolve(feedback);
      });
    },
    setAlertOn(context, payload) {
      context.commit("updateAlertOn", payload);
    },
    setSecurity(context, payload) {
      context.commit("updateSecurity", payload);
    },
    setAccountSetup(context, payload) {
      context.commit("updateAccountSetup", payload);
    },
    setAttachmentPath(context, payload) {
      context.commit("updateAttachmentPath", payload);
    },
    setDailyStatementParam(context, payload) {
      context.commit("updateDailyStatementParam", payload);
    },
    setWinLoseParam(context, payload) {
      context.commit("updateWinLoseParam", payload);
    },
    setGameResultParam(context, payload) {
      context.commit("updateGameResultParam", payload);
    },
    setTransferListParam(context, payload) {
      context.commit("updateTransferListParam", payload);
    },
    setBonusAndAdjustmentParam(context, payload) {
      context.commit("updateBonusAndAdjustmentParam", payload);
    },
    setDailyStatementNestParam(context, payload) {
      context.commit("updateDailyStatementNestParam", payload);
    },
    setWinLoseNestParam(context, payload) {
      context.commit("updateWinLoseNestParam", payload);
    },
  }
};
